// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BR8tt","label":"styles_label__s487p"};